import styled from "styled-components";
import Modal from "./Modal";
import ModalInfo from "./ModalInfo";

export const LargeModal = styled(Modal)`
  &.ant-modal {
    width: 544px !important;
  }
`;

export const LargeModalCreditInfo = styled(ModalInfo)`
  // desktop
  @media only screen and (min-width: 768px) {
    & {
      align-items: flex-start;
      text-align: left;
    }
  }
`;
